import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBurst: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBurst"><Path d="M11 19H13V23H11V19ZM8.91406 16.5L5 20.4141L3.58594 19L7.5 15.0859L8.91406 16.5ZM20.4141 19L19 20.4141L15.0859 16.5L16.5 15.0859L20.4141 19ZM5 11V13H1V11H5ZM23 11V13H19V11H23ZM8.91406 7.5L7.5 8.91406L3.58594 5L5 3.58594L8.91406 7.5ZM20.4141 5L16.5 8.91406L15.0859 7.5L19 3.58594L20.4141 5ZM11 1H13V5H11V1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBurst;
